import { CountryCode } from 'libphonenumber-js';
import * as yup from 'yup';
import 'yup-phone';

const CANADA_COUNTRY_CODE = 'CA' as CountryCode;

const phoneValidator = yup.string().phone(CANADA_COUNTRY_CODE);

export default phoneValidator;
